// Image Slider
const imageSlider = document.querySelectorAll('[data-slider="image-slider"]');
const tagSlider = document.querySelectorAll('[data-slider="tag-slider"]');

const tagSliderOptions = {
  speed: 800,
  effect: 'creative',
  allowTouchMove: false,
  loop: true,
  creativeEffect: {
    prev: {
      translate: ['-50%', 0, 0],
    },
    next: {
      translate: ['-50%', 0, 0],
    },
  },
};

tagSlider.forEach((el) => new Swiper(el, tagSliderOptions));

const imageSliderOptions = {
  direction: 'vertical',
  speed: 800,
  allowTouchMove: false,
  loop: true,
  watchOverflow: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: null,
  },
  effect: 'creative',
  creativeEffect: {
    prev: {
      translate: [0, 0, -1],
    },
    next: {
      translate: [0, '100%', 0],
    },
  },
};

imageSlider.forEach((el, i) => {
  imageSliderOptions.thumbs.swiper = tagSlider[i]?.swiper;
  new Swiper(el, imageSliderOptions);
});
